import { IsNotEmpty, MaxLength, Validate, IsDefined } from 'class-validator';
import { DisplayNameValidation } from 'src/core/customValidator/displayNameValidator';

import { EntityModel } from 'src/core/services/data/models';
import { DataService, property } from 'src/core/services/data.service';
import { BookemZulu as Model } from 'src/core/services/data/JayDataContext';

export class RegionDataService extends DataService<typeof Model.General.Logic.ViewModels.RegionItem, Model.General.Logic.ViewModels.RegionItem, RegionItem> {
	protected map(entity: Model.General.Logic.ViewModels.RegionItem): RegionItem {
		return new RegionItemModel(entity);
	}

	public static make(ctx?: any): RegionDataService {
		return new RegionDataService(ctx, ctx => ctx.Regions);
	}

	public add(defaultLanguage: string) {
		const entity = new Model.General.Logic.ViewModels.RegionItem();
		(entity as any).dynamicProperties['displayName'] = { [defaultLanguage]: '' };
		return entity;
	}
}

export class RegionItemModel extends EntityModel<Model.General.Logic.ViewModels.RegionItem, RegionItem> implements RegionItem {

	@property<RegionItemModel>(o => o.entity.id, (o, value) => o.entity.id = value)
	public id: number;

	@property<RegionItemModel>(o => o.entity.code, (o, value) => o.entity.code = value)
	@IsDefined({ message: 'code is required' })
	@MaxLength(15, { message: 'code is to long' })
	public code: string;

	@property<RegionItemModel>(o => o.entity.codeIso2, (o, value) => o.entity.codeIso2 = value)
	@MaxLength(15, { message: 'code is to long' })
	public codeIso2: string;

	@property<RegionItemModel>(o => o.entity.parentRegionId, (o, value) => o.entity.parentRegionId = value)
	public parentRegionId?: number;

	@property<any>(o => o.entity.dynamicProperties, (o, value) => o.entity.dynamicProperties = value)
	@Validate(DisplayNameValidation, ['en'])
	public dynamicProperties: {};
}



// WEBPACK FOOTER //
// ./src/app/general/regions/form/region-form.data.ts